/* eslint-disable no-param-reassign */
import { RouteName } from '@/router/routes';
import { RootState } from '@/store';
import { Router } from 'vue-router';
import { Store } from 'vuex';
import Net, { NetErrorType, RspError } from '_c/util/net';
import { toast } from '@/component/kk-toast';
import { CommonRsp } from '_c/util/net/typings';
import { logger } from '_c/util/logger';
import { MessageManager } from '_c/business/manager/message';

/**
 * 网络错误时进行全局处理
 */
export function handlerNetFail(router: Router, store: Store<RootState>) {
  Net.afterResponseError((err) => {
    if (err.type === NetErrorType.authError) {
      logger.error(`[requestAuthFail] cookie: ${document.cookie}`);
      requestAuthFail(router, store);
      err.isHandled = true;
      throw err;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const isAutoHandleError = (err.config?.autoHandleError) ?? false;
    if (err.isHandled || !isAutoHandleError) {
      // 错误已经被处理，或者不需要处理
      throw err;
    }
    if (err.type === NetErrorType.businessError) {
      showErrorToast(err);
      err.isHandled = true;
      throw err;
    }
    throw err;
  });
}

let isAuthFailHanleLock = false;

/**
 * 处理鉴权失败的请求
 */
async function requestAuthFail(router: Router, store: Store<RootState>) {
  if (isAuthFailHanleLock) return;
  if (router.currentRoute.value.name === RouteName.account) {
    // 当前在登录页，不处理
    return;
  }
  isAuthFailHanleLock = true;
  try {
    store.commit('login/updateShowLogoutPopup', true);
    MessageManager.getInstance().logout();
    isAuthFailHanleLock = false;
  } catch (error) {
    isAuthFailHanleLock = false;
  }
}

/**
 * 提示错误
 */
function showErrorToast(err: RspError) {
  const msg = (err.data as CommonRsp).msg || err.msg || '网络异常';
  toast({
    type: 'error',
    content: msg,
  });
}
